import { render } from "./socialTabs.vue?vue&type=template&id=37ca8112"
import script from "./socialTabs.vue?vue&type=script&lang=js"
export * from "./socialTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__